









import { Component, Prop, Vue } from "vue-property-decorator";
import { RecordingController } from "@share/web-conferences/helpers/RecordingController";
import RingLoader from "@share/common/RingLoader.vue";

@Component({
    name: "RecordingButton",
    components: { RingLoader }
})
export default class RecordingButton extends Vue {
    @Prop({ required: true }) controller: RecordingController;

    isBusy = false;

    get title() {
        if (this.controller.canControlRecording) {
            return this.controller.isBeingRecorded ? this.$t('web-conferences.recording.stop') : this.$t('web-conferences.recording.start');
        }

        return this.controller.isBeingRecorded ? this.$t('web-conferences.recording.isBeingRecorded') : this.$t('web-conferences.recording.NotRecording');
    }

    async onClick() {
        if (this.isBusy) {
            return;
        }

        this.isBusy = true;

        await this.controller.toggle();

        this.isBusy = false;
    }
}
